'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.addCallbacks = addCallbacks;
exports.addCallback = addCallback;
exports.getCallback = getCallback;

var _assign = require('lodash/assign');

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var callbacks = {};

function addCallbacks(objectWithNamedCallbacks) {
	(0, _assign2.default)(callbacks, objectWithNamedCallbacks);
}

function addCallback(name, callback) {
	callback[name] = callback;
}

function getCallback(name) {
	return name && callbacks[name];
}


//////////////////
// WEBPACK FOOTER
// ./~/linksoft/data-tables/callbacks.js
// module id = 482
// module chunks = 0